/**
 * API Configuration Utility
 *
 * Centralized function to get the API base URL with support for:
 * 1. Runtime configuration (window.__ENV__.API_URL) - injected by Docker
 * 2. Build-time environment variable (VITE_API_URL)
 * 3. Fallback to /api for local development with nginx proxy
 */

export const getApiBaseUrl = (): string => {
  // @ts-ignore - window.__ENV__ is injected at runtime by Docker entrypoint
  const runtimeApiUrl = (window as any).__ENV__?.API_URL;
  const buildTimeApiUrl = import.meta.env.VITE_API_URL;

  if (runtimeApiUrl) {
    return `${runtimeApiUrl}/api`;
  }
  if (buildTimeApiUrl && buildTimeApiUrl !== '/api') {
    return `${buildTimeApiUrl}/api`;
  }
  return '/api'; // Fallback for local development with proxy
};
